export const Bookmarkcartdata = [
    {
        "img":"01.jpg",
        "id":"1",
        "header":"Admin Template",
        "fillstar":false,
        "link":"http://admin.pixelstrap.com//ltr/landing-page.html",
        "content":"is beautifully crafted, clean and modern designed admin theme with 6 different demos and light - dark versions.",
        "title":"General",
        "class":"collection_0",
        "class2":"favourite_0"
    },
    {
        "img":"02.jpg",
        "id":"2",
        "header":"Universal Template",
        "fillstar":false,
        "link":"https://angular.pixelstrap.com/universal/landing",
        "content":"Universal is beautifully crafted, clean and modern designed admin theme",
        "title":"General",
        "class":"collection_1",
        "class2":"favourite_1"
    },
    {
        "img":"03.jpg",
        "id":"3",
        "fillstar":false,
        "header":"Angular Theme",
        "link":"https://angular.pixelstrap.com/cuba/landing",
        "content":"Cuba is beautifully crafted, clean and modern designed admin theme",
        "title":"Fs",
        "class":"collection_2",
        "class2":"favourite_2"
    },
    {
        "img":"04.jpg",
        "id":"4",
        "fillstar":false,
        "header":"Multikart Admin",
        "link":"http://themes.pixelstrap.com/multikart/back-end/index.html",
        "content":"Multikart Admin is modern designed admin theme",
        "title":"General",
        "class":"collection_3",
        "class2":"favourite_3"
    },
    {
        "img":"05.jpg",
        "id":"5",
        "fillstar":false,
        "header":"Ecommerece theme",
        "link":"http://themes.pixelstrap.com/multikart",
        "content":"Multikart HTML template is an apparently simple but highly functional tempalate designed for creating a flourisahing online business.",
        "title":"General",
        "class":"collection_4",
        "class2":"favourite_4"
    },
    {
        "img":"06.jpg",
        "id":"6",
        "fillstar":false,
        "header":"Tovo app landing page",
        "link":"http://vue.pixelstrap.com/tovo/home-one",
        "content":"Amazing Landing Page With Easy Customization",
        "title":"Fs",
        "class":"collection_5",
        "class2":"favourite_5"
    }
]